// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-link {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.quick-link-select {
  width: 30em !important;
}
.quick-link-operator {
  display: flex;
  gap: 1em;
  padding-left: 0.5em;
  color: #777776;
  font-size: 0.9em;
}
.quick-link-operator-container {
  padding-left: 0.5em;
}
.quick-link-operator span:not(:first-child) {
  margin-left: -0.7em;
}
.quick-link-operator-feedback {
  color: #777776;
  font-size: 0.8em;
  margin-left: 1em !important;
}
.quick-link-operator-selected {
  color: black;
  font-weight: 500;
}
.quick-link-title {
  font-size: 1.5em;
  font-weight: bold;
}
.quick-link-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.quick-link-form {
  display: flex;
  flex-direction: column;
}
.quick-link-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
}
.quick-link-form-radio-group {
  width: 100%;
  margin: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.quick-link-form-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-check {
  margin: 1em;
}

.link-content-container {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/views/quickLink/quickLinkForm/quickLinkForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,sBAAA;AAAF;AAGC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cEXU;EFYV,gBAAA;AADF;AAGE;EACC,mBAAA;AADH;AAIE;EACC,mBAAA;AAFH;AAKE;EACC,cEvBS;EFwBT,gBAAA;EACA,2BAAA;AAHH;AAME;EACC,YAAA;EACA,gBAAA;AAJH;AAQC;EACC,gBAAA;EACA,iBAAA;AANF;AASC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEhDM;AFyCR;AAUC;EACC,aAAA;EACA,sBAAA;AARF;AAUE;EC1DD,aAAA;EACA,6BD0DgB;ECzDhB,uBDyD8B;EAC5B,eAAA;AANH;AASE;EACC,WAAA;EACA,WAAA;EC3DF,aAAA;EACA,sBAAA;EACA,2BD0DsB;ECzDtB,uBDyDkC;AAJnC;AAOE;ECrED,aAAA;EACA,uBDqEgB;ECpEhB,mBDoEwB;AAHzB;;AAQA;EACC,WAAA;AALD;;AAQA;EACC,WAAA;AALD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.quick-link {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-select {\n\t\twidth: 30em !important;\n\t}\n\t\n\t&-operator {\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\tpadding-left: 0.5em;\n\t\tcolor: $dark-grey;\n\t\tfont-size: 0.9em;\n\n\t\t&-container {\n\t\t\tpadding-left: 0.5em;\n\t\t}\n\n\t\tspan:not(:first-child) {\n\t\t\tmargin-left: -0.7em;\n\t\t}\n\n\t\t&-feedback {\n\t\t\tcolor: $dark-grey;\n\t\t\tfont-size: 0.8em;\n\t\t\tmargin-left: 1em !important;\n\t\t}\n\n\t\t&-selected {\n\t\t\tcolor: black;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&-radio-group {\n\t\t\twidth: 100%;\n\t\t\tmargin: 1em;\n\t\t\t@include flexColumn(flex-start, flex-start);\n\t\t}\n\n\t\t&-radio {\n\t\t\t@include flex(center, center);\n\t\t}\n\t}\n}\n\n.form-check {\n\tmargin: 1em;\n}\n\n.link-content-container{\n\twidth: 100%;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
